<woa-modal-page-layout [title]="'woa.heading.change-password.title'">
    <woa-form (onSubmit)="changePassword()">
        <input class="hidden" [hidden]="true" [value]="identityModel.loginIdentity()" [attr.autocomplete]="'username'">
        <woa-password-field [(ngModel)]="oldPassword" name="oldPassword"
                            [label]="'woa.label.change-password.currentPassword'"
                            required [minlength]="'8'" [maxlength]="'20'"
                            [autocomplete]="'current-password'"></woa-password-field>
        <woa-password-field [(ngModel)]="newPassword" name="newPassword"
                            [label]="'woa.label.change-password.newPassword'"
                            required [minlength]="'8'" [maxlength]="'20'"
                            [autocomplete]="'new-password'"></woa-password-field>
    </woa-form>
    <woa-button woa-page-footer-control [label]="'woa.button.change-password.changePassword'"
                id="button-change-password" (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
